<template>
	<div class="list-upload-mode-item flex flex-col mb-1 last:mb-0 cursor-pointer" @click="$emit('onClickItem', file)">
		<div v-if="file.status === 'success'" class="flex items-center">
			<FileIcon class="text-xl mr-3" :extension="file.response.extension"/>
			<span class="truncate" :title="file.response.file_name">{{ file.response.file_name }}</span>
		</div>
	</div>
</template>

<script>
import FileIcon from "./FileIcon";

export default {
	name: "ListUploadMode",
	components: { FileIcon },
	props: {
		file: {
			type: Object,
			required: true
		}
	},
	emits: {
		onClickItem: {}
	}
};
</script>
